function setRem () {
  const width = document.documentElement.getBoundingClientRect().width
  document.documentElement.style.fontSize = width / 10 + 'px'
}

export default setRem
